import React from 'react';

interface IProps {
  size?: number| string;
  fill?: string;
}

const AddIcon = ({ size = "24", fill }: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? fill : '#231F20'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 18.75V12.75H5.25V11.25H11.25V5.25H12.7499V11.25H18.75V12.75H12.7499V18.75H11.25Z"
        fill={fill}
      />
    </svg>
  );
};

export default AddIcon;
